module.exports = __webpack_public_path__ + "img/no_authority.27b5c5b3.png";